<template><div class="amplitude-session-replay-starter"></div></template>
<script setup lang="ts">
    import {useAmplitudeSessionReplay} from '#imports';

    useAmplitudeSessionReplay();
</script>

<style scoped>
    .amplitude-session-replay-starter {
        display: none;
    }
</style>
